import ALaCarteItem from './ALaCarteItem';

export default ALaCarteItem;
